import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Composant qui redirige de /litiges/:cle vers /reclamations/:id
 */
export default function LitigeRedirect() {
    const { cle } = useParams();
    const [reclamationId, setReclamationId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchReclamationId = async () => {
            try {
                const response = await axios.get(`/api/litiges/${cle}/reclamation`);
                setReclamationId(response.data.reclamationId);
                setLoading(false);
            } catch (err) {
                setError('Impossible de trouver le dossier correspondant');
                setLoading(false);
            }
        };

        fetchReclamationId();
    }, [cle]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <CircularProgress />
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Redirection en cours...
                </Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Typography variant="h6" color="error">
                    {error}
                </Typography>
            </Box>
        );
    }

    return <Navigate to={`/reclamations/${reclamationId}`} replace />;
}